import { InvoiceApiStatusType as InvoiceStatus } from 'anchor-scout-common/types';
export { InvoiceStatus };
export function isItemMarkedTaxable(item) {
    const { taxability } = item;
    return taxability.source !== 'none' && taxability.taxable;
}
export function itemPeriod(item) {
    const { period } = item;
    if (period.type === 'delivery') return null;
    if (period.type === 'fullTerm') return {
        from: period.from,
        to: period.to,
        proRata: null
    };
    return {
        from: period.from,
        to: period.to,
        proRata: period.proRata
    };
}
